import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { NetSuiteGetCreditItemsResponseSchema } from '@vy/api-definition';
import { queryKeys } from '../../services/query-key/query-keys';

export function useCreditItems() {
  return useQuery(queryKeys.creditItems(), () => getCreditItems());
}

async function getCreditItems() {
  const privateApi = getPrivateApi();
  const creditItems = await privateApi.netSuiteGetCreditItems();

  return NetSuiteGetCreditItemsResponseSchema.parse(creditItems);
}
